import { Label, LargeRadiusInput } from 'styles/Styles.styled';
import { useField, useFormikContext } from 'formik';
import { useEffect } from 'react';
import { ALLOWED_SYMBOLS_ERROR } from 'util/allowedSymbolsValidationUtils';
import { toaster } from 'components/v2/toast';
import { StyledInputErrorMessage, StyledInputWrapper } from './styled';
import { NormalizeSpaces } from 'util/utils';

const LargeRadiusTextInput = ({ label, trim, ...props }: any) => {
  const [field, meta, helpers] = useField(props);
  const { submitCount } = useFormikContext();

  const applyTrim = (value: string) => {
    const normalized = NormalizeSpaces(value);
    if (normalized !== value) {
      helpers.setValue(normalized);
      toaster({
        severity: 'yellow-exclamation-warning',
        summary: 'Extra spaces have been removed.',
        details: 'Input fields cannot contain leading, trailing or double spaces.',
      });
    }
  };

  useEffect(() => {
    if (trim && !props.disabled && submitCount > 0 && typeof field.value === 'string') {
      applyTrim(field.value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitCount]);

  const rawError = meta.touched ? meta.error : undefined;

  const shouldShowBottomError =
    rawError && !props.supressErrors && (props.shouldShowBottomError ? props.shouldShowBottomError(rawError) : true);

  const shouldHighlightBorder =
    rawError && (props.shouldHighlightBorder ? props.shouldHighlightBorder(rawError) : rawError === ALLOWED_SYMBOLS_ERROR);

  const mergedStyle = {
    ...(props.style ?? {}),
    ...(shouldHighlightBorder && {
      borderColor: props.theme?.colors?.systemStatusError,
    }),
  };

  const renderErrorMessage = () => {
    if (!rawError) return null;

    if (props.renderErrorMessage) {
      return props.renderErrorMessage(rawError);
    }

    return rawError;
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    if (trim && !props.disabled && typeof field.value === 'string') {
      applyTrim(field.value);
    }
    field.onBlur(e);
  };

  return (
    <>
      {label && <Label htmlFor={props.id || props.name}>{label}</Label>}

      <StyledInputWrapper>
        <LargeRadiusInput {...field} {...props} style={mergedStyle} onBlur={handleBlur} />

        {shouldShowBottomError && <StyledInputErrorMessage>{renderErrorMessage()}</StyledInputErrorMessage>}
      </StyledInputWrapper>
    </>
  );
};

export default LargeRadiusTextInput;
